var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"fixed","top":"50px","right":"10px","z-index":"1001"},attrs:{"id":"g_id_onload","data-prompt_parent_id":"g_id_onload","data-method":"one-tap","data-client_id":_vm.clientId,"data-login_uri":_vm.loginUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }